<template>
  <div class="data-ops-panel">
    <el-alert
      v-if="localOnly"
      title="数据维护已开启“不同步对端”"
      description="本模块的 Redis 导入、新增、修改、删除和数据迁移只操作当前服务器。"
      type="warning"
      show-icon
      :closable="false"
    />
    <div class="data-ops-switch">
      <div class="switch-title">
        <span>数据维护</span>
        <strong>{{ currentTabMeta.desc }}</strong>
        <el-switch v-model="localOnly" active-text="不同步对端" />
      </div>
      <div class="switch-actions">
        <button
          v-for="item in visibleDataTabs"
          :key="item.name"
          type="button"
          class="switch-btn"
          :class="{ active: item.name === activeDataTab }"
          @click="activeDataTab = item.name"
        >
          <span>{{ item.label }}</span>
          <small>{{ item.meta }}</small>
        </button>
      </div>
    </div>

    <component
      :is="currentTabMeta.component"
      :key="activeDataTab"
      :server-name="serverName"
      :mazda-post="scopedMazdaPost"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

import MazdaJsonRedisPanel from '@/components/mazda/panels/MazdaJsonRedisPanel.vue';
import MazdaRedisQueryPanel from '@/components/mazda/panels/MazdaRedisQueryPanel.vue';
import MazdaLegacyRedisPanel from '@/components/mazda/panels/MazdaLegacyRedisPanel.vue';
import MazdaSqlLogPanel from '@/components/mazda/panels/MazdaSqlLogPanel.vue';
import MazdaCrawlerBoxPanel from '@/components/mazda/panels/MazdaCrawlerBoxPanel.vue';
import { useMazdaWriteScope } from '@/composables/mazda/useMazdaWriteScope';

const props = defineProps({
  serverName: { type: String, required: true },
  mazdaPost: { type: Function, required: true },
});

const DATA_WRITE_ENDPOINTS = [
  'uploadJson',
  'migrateSeachcarIver',
  'add_redis_data',
  'updata_redis_data',
  'updata_short_data',
  'delete_redis_data',
  'legacyRedisSave',
  'legacyRedisDelete',
];

const { localOnly, scopedMazdaPost } = useMazdaWriteScope(
  props.mazdaPost,
  DATA_WRITE_ENDPOINTS,
);

const dataTabs = [
  {
    name: 'jsonRedis',
    label: 'Redis 导入',
    meta: 'JSON',
    desc: 'JSON 写入 DB1',
    component: MazdaJsonRedisPanel,
  },
  {
    name: 'queryRedis',
    label: 'Redis 查询',
    meta: 'api:olinfo',
    desc: '按分类读取 Redis',
    component: MazdaRedisQueryPanel,
  },
  {
    name: 'legacyRedis',
    label: '日志及其他数据',
    meta: 'DB1',
    desc: '日志与其他 Redis 数据',
    component: MazdaLegacyRedisPanel,
  },
  {
    name: 'sqlLog',
    label: '车型数据收集',
    meta: 'SQL',
    desc: '车型与版本数据收集',
    component: MazdaSqlLogPanel,
  },
  {
    name: 'crawlerBox',
    label: '测试接头',
    meta: 'CrawlerBox',
    desc: '测试接头开关',
    component: MazdaCrawlerBoxPanel,
  },
];

const activeDataTab = ref('queryRedis');
const visibleDataTabs = computed(() => dataTabs.filter((item) => item.name !== 'crawlerBox'));
const currentTabMeta = computed(() => (
  visibleDataTabs.value.find((item) => item.name === activeDataTab.value) || visibleDataTabs.value[0]
));
</script>

<style scoped>
.data-ops-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.data-ops-switch {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 14px;
  padding: 14px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(225, 232, 242, 0.95);
  box-shadow: 0 10px 24px rgba(29, 46, 76, 0.06);
}

.switch-title {
  min-width: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}

.switch-title span {
  color: #1f2d3d;
  font-size: 17px;
  font-weight: 800;
}

.switch-title strong {
  color: #7c8798;
  font-size: 12px;
  font-weight: 600;
}

.switch-actions {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(5, minmax(120px, 1fr));
  gap: 8px;
}

.switch-btn {
  min-width: 0;
  min-height: 54px;
  padding: 9px 10px;
  border-radius: 12px;
  border: 1px solid #dfe7f2;
  background: #ffffff;
  color: #344054;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  text-align: left;
  transition: border-color 0.18s ease, background-color 0.18s ease, box-shadow 0.18s ease;
}

.switch-btn span {
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
}

.switch-btn small {
  color: #8a94a6;
  font-size: 11px;
  line-height: 1.2;
}

.switch-btn:hover,
.switch-btn.active {
  border-color: rgba(64, 158, 255, 0.58);
  background: #f3f8ff;
  box-shadow: 0 8px 18px rgba(64, 158, 255, 0.1);
}

.switch-btn.active span {
  color: #2f6fd6;
}

@media (max-width: 1180px) {
  .data-ops-switch {
    flex-direction: column;
  }

  .switch-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 620px) {
  .switch-actions {
    grid-template-columns: 1fr;
  }
}
</style>
